<template>
	<div>
		<img :src="posterSource" alt="image" style="position: absolute;width: 100%;height: 100%;left: 0;top: 0;object-fit: cover;object-position: center"/>

		<div v-observe-visibility="onVisibilityChange">
			<div v-if="videoBlockType==='pb' && showVideo">
				<partial-block-video v-bind="$props" @pHandleUserClose="hidePlayButton('userClose')" @pVideoEnded="hidePlayButton('end')" @pVideoStarted="hidePlayButton('start')" @videoClicked="handleVClick"/>
			</div>

			<full-block-video v-if="showVideo && videoBlockType==='fb'" :posterSource="posterSource" v-bind="$props" @fVideoStarted="hidePlayButton('start')" @handleUserClose="hidePlayButton('userClose')" @videoClicked="handleVClick" @videoClosed="hidePlayButton('end')"/>
			<product-element v-else :hidePlayBtn="hidePlayBtn" v-bind="$props" @onRegionClick="onRegionClick" @srcFromProduct="handleSrcFromProduct"/>
		</div>
	</div>
</template>

<script>
import {defineComponent} from "vue";
import blockElementMixin from "@/mixins/blockElementMixin";
import InblockVideosMixin from "@/features/inblock-videos/InblockVideosMixin";
import FullBlockVideo from "@/features/inblock-videos/FullBlockVideo.vue";
import PartialBlockVideo from "@/features/inblock-videos/PartialBlockVideo.vue";
import ProductElement from "@/components/block/elements/ProductElement.vue";
import featureMixin from "@/mixins/featureMixin";
import {mapActions, mapGetters, mapState} from "vuex";
import Lytics from "../../../classes/Lytics";
import {PRODUCT_REGION_CLICK_VALID} from "@/components/block/BlockEvents";
import {getProductSku} from "@/store/modules/product";

export default defineComponent({
	name: "ProductBlockVideoElement",
	components: {ProductElement, FullBlockVideo, PartialBlockVideo},
	mixins: [featureMixin, blockElementMixin, InblockVideosMixin],
	data() {
		return {
			blockVideoState: false,
			/*posterSource: null,*/
			featurePath: "blockVideos.fullBlock",
			videoProduct: {},
			videoBlockType: "",
			hidePlayBtn: false,
			skuLeft: "",
			skuRight: "",
			currentLoop: 0,
			imgSrc: null
		};
	},
	computed: {
		...mapState(["currentPageNumber"]),
		...mapGetters("landingPage", ["currentFlyer"]),
		...mapGetters(["storeId", "language"]),
		showVideo() {
			return this.blockVideoState && this.isVisible;
		},
		posterSource() {
			return this.imgSrc || this.blockData?.images[0]?.image;
		}
	},
	created() {
		//this.posterSource = this.blockData?.images[0]?.image;
		const products = this.blockData?.products;
		products.forEach((prod) => {
			const isVideo = (prod.actionType || prod.sku).toLowerCase();
			if (isVideo.includes("inblock") || isVideo.includes("animate")) {
				this.videoProduct = prod;
				if (this.fileFormat) this.videoBlockType = "pb";
				else this.videoBlockType = prod?.fullBlock == true ? "fb" : "pb";
				if (this.videoProduct?.inblockAutoplay) {
					this.hidePlayBtn = true;
				}

				if (this.fileFormat) {
					this.hidePlayBtn = true;
					setTimeout(() => {
						this.blockVideoState = true;
					}, this.videoProduct?.inblockDelay * 1000);
				}

				setTimeout(() => {
					this.blockVideoState = this.videoProduct.inblockAutoplay;
				}, this.videoProduct?.inblockDelay * 1000);

				this.videoProduct.noPop ? this.block.classes.noPop = true : "";
				this.setSku(prod);
			}

		});
		// this.handlePlay();
	},
	methods: {
		...mapActions("events", ["triggerEvent"]),
		...mapActions("product", ["isValidProduct"]),
		onRegionClick(region, rf) {
			if (rf !== "productRegion" && (rf === "inblock"))
				region.isVideo ? this.blockVideoState = true : this.blockVideoState = false;
			console.log("onRegionClick:", region);
		},
		hidePlayButton(rf) {
			// console.log('Request from ',rf)
			if (rf === "start") this.hidePlayBtn = true;
			else if (rf === "end") {
				if (this.videoProduct?.inblockLoop) {
					this.hidePlayBtn = true;
					this.blockVideoState = false;
					this.currentLoop++;

					if ((this.currentLoop < this.videoProduct?.loopCount) || this.videoProduct?.loopCount === 0) {
						setTimeout(() => {
							this.blockVideoState = true;
						}, this.videoProduct?.inblockDelay * 1000);
					} else {

						this.hidePlayBtn = true;
						this.blockVideoState = true;
					}

				} else {
					if (this.fileFormat) {
						this.hidePlayBtn = true;
						this.blockVideoState = true;
					} else {
						this.hidePlayBtn = false;
						this.blockVideoState = false;
					}

				}
			} else if (rf === "userClose") {
				this.blockVideoState = false;
				this.hidePlayBtn = false;
			}
		},
		handleVClick() {
			const actionTypeSku = (this.videoProduct?.actionType)?.toLowerCase();
			if (!this.videoProduct.sku.includes("|")) {
				if (actionTypeSku === "inblocksku" || actionTypeSku === "animatesku") {
					this.triggerEvent({
						event: "productRegionClick",
						data: {
							currentFlyer: this.currentFlyer,
							product: this.videoProduct
						}
					});
				}
			} else {
				if (this.videoProduct.sku.toLowerCase() === "inblock") return;
				const oldVal = this.videoProduct.sku;
				if (this.videoProduct.sku.includes("|")) this.videoProduct.sku = this.skuRight;
				this.triggerEvent({
					event: "productRegionClick",
					data: {
						currentFlyer: this.currentFlyer,
						product: this.videoProduct
					}
				});
				this.videoProduct.sku = oldVal;
			}

			if(this.isValidProduct(this.videoProduct)){
				this.triggerEvent({event: PRODUCT_REGION_CLICK_VALID, data: {product: this.videoProduct, sku: getProductSku(this.videoProduct.sku), ...this}})
			}
			Lytics.TriggerInBlockVideoClick({
				url: this.videoProduct?.url,
				page_number: this.currentPageNumber
			});

		},
		setSku(p) {
			if (!p.sku.includes("|")) return;
			this.skuLeft = p.sku.split("|")[0];
			this.skuRight = p.sku.split("|")[1];
		},

		onVisibilityChange(isVisible) {
			if (isVisible) {
				this.handlePlay();
			}
		},
		handlePlay() {
			this.blockData?.products.forEach((prod) => {
				const actionType = (prod.actionType || prod.sku).toLowerCase();

				if (actionType.includes("inblock") || actionType.includes("animate")) {
					const delay = (prod.inblockDelay) ? prod.inblockDelay : 2;
					const removedRegions = prod.clickRegions.filter((region) => !region);
					const updatedRegions = prod.clickRegions.filter(Boolean);
					if (this.fileFormat) {
						setTimeout(() => {
							this.blockVideoState = true;
							prod.clickRegions = [...updatedRegions, ...removedRegions];
						}, delay * 1000);
						return;
					}
					if (prod.inblockAutoplay) {

						setTimeout(() => {
							this.blockVideoState = prod.inblockAutoplay;
							prod.clickRegions = [...updatedRegions, ...removedRegions];
						}, delay * 1000);
					}
				} else {
					this.blockVideoState = false;
				}

			});
		},
		// eslint-disable-next-line no-unused-vars
		handleSrcFromProduct(imageSrc) {
			this.imgSrc = imageSrc;
		}
	}
});
</script>


<style lang="scss">
//this added for making inblock videoelemnt clickable after search
.grid-renderer .ProductBlockVideoElement.flyer-block {
  > div {
	> div {
	  position: absolute;
	  top: 0;
	  bottom: 0;
	  left: 0;
	  right: 0;

	  > .product-block {
		width: 100%;
		height: 100%;
	  }
	}
  }
}

.flyer-block.ProductBlockVideoElement:not(.noPop) {
  position: relative;

  &:hover, &:focus {
	transform: scale(1.02);
	box-shadow: 0 0 50px rgba(0, 0, 0, 0.3);
	z-index: 9999;
	outline: none;
  }

  /* .poster-source {
     position: absolute;
     width: 100%;
     height: 100%;
     left: 0;
     top: 0;
     object-fit: fill;
   }*/
}

</style>
